/* eslint-disable no-nested-ternary */
import React, { useContext } from 'react';
import { HeroFlattenImage as HeroFlattenImageComponent } from '@thd-olt-component-react/hero';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import {
  arrayOf,
  string,
  number,
  shape
} from 'prop-types';
import { HomepageContext } from './context/HomepageContext';

export function HeroFlattenImage({
  id,
  layoutRendererPrerenderedChildIndex,
  mobilePreviewImage,
  previewImage,
  proAnalyticsCampaign,
  proAnalyticsComponent
}) {

  const { proCustomerSegment, isB2C } = useContext(HomepageContext);

  return (
    <ErrorBoundary name="hero-flatten-image">
      <QueryProvider cacheKey="hero-flatten-image-cache" defaultVariables={{ isCarousel: false }}>
        <HeroFlattenImageComponent
          componentId={id}
          layoutRendererPrerenderedChildIndex={layoutRendererPrerenderedChildIndex}
          isB2C={isB2C}
          proAnalyticsCampaign={proAnalyticsCampaign}
          proAnalyticsComponent={proAnalyticsComponent}
          proCustomerSegment={proCustomerSegment}
          livePreviewData={{
            previewImage,
            mobilePreviewImage
          }}
        />
      </QueryProvider>
    </ErrorBoundary>
  );
}

HeroFlattenImage.propTypes = {
  id: string,
  mobilePreviewImage: shape({
    damContentSelector: shape({
      assetData: arrayOf(
        shape({
          selectedImageUrl: string,
        })
      ),
    }),
    damDownloadedContent: shape({
      url: string,
    }),
    imageHotspot: shape({
      id: string,
      componentName: string,
    })
  }),
  previewImage: shape({
    damContentSelector: shape({
      assetData: arrayOf(
        shape({
          selectedImageUrl: string,
        })
      ),
    }),
    damDownloadedContent: shape({
      url: string,
    }),
    imageHotspot: shape({
      id: string,
      componentName: string,
    })
  }),
  layoutRendererPrerenderedChildIndex: number,
  proAnalyticsCampaign: string,
  proAnalyticsComponent: string,
};

HeroFlattenImage.defaultProps = {
  id: '',
  layoutRendererPrerenderedChildIndex: undefined,
  proAnalyticsCampaign: undefined,
  proAnalyticsComponent: undefined,
  mobilePreviewImage: undefined,
  previewImage: undefined,
};
